import * as t from "io-ts";
import { decode } from "io-ts-promise";
import { createFractionTypes } from "dora-contracts";

const { baseFractionT, fractionT, fractionsT } = createFractionTypes({
  decimal: t.string,
});

export type BaseFraction = t.TypeOf<typeof baseFractionT>;
export type Fraction = t.TypeOf<typeof fractionT>;
export const decodeFractions = decode(fractionsT);
export const decodeFraction = decode(fractionT);
